import { post } from './index';

import { ISigner } from 'models/signer';

export const exchangeToken = (token: string) => post<{ token: string }, ISigner>('/sign/magic-token', { token });
export const setConsentGiven = (token: string) => post<{ token: string }, ISigner>('/sign/consent-given', { token });
